<div class="advanced-edit-button">
  <i class="fas fa-pencil-alt"></i>
  <span>
    {{ 'UI.Button.AdvancedEdit' | translate }}
  </span>
</div>
